import React from 'react'
import Subscription from '../../components/Subscription/Subscription'

const SubscriptionSection = () => {
    return (
        <Subscription/>
    )
}

export default SubscriptionSection
